import cn from "@/v2-ui/utils/utils.cn"
import { errorToast } from "@/v2-ui/toast"
import Page, { type PageProps } from "@/v2-backoffice-client/components/page"
import UserTable from "@/v2-backoffice-client/user/UserTable"
import UserCreateManyButton from "@/v2-backoffice-client/user/create/many/UserCreateManyButton"
import { useUserStatusCountsQuery } from "@/v2-backoffice-client/user/counts/user.counts.query"

export type UserPageProps = PageProps

function UserPage(props: UserPageProps) {
  const { className, ...pageProps } = props

  const { data, loading, error } = useUserStatusCountsQuery()
  const counts = data?.getUserStatusCounts
  const statuses = data?.getUserStatuses ?? []

  errorToast(error, {
    title: "Failed to query for user status counts",
  })

  return (
    <Page className={cn("user-page", className)} {...pageProps}>
      <Page.Header>
        <Page.Title>Users</Page.Title>
        <Page.Header.Actions>
          <UserCreateManyButton />
        </Page.Header.Actions>
      </Page.Header>

      <Page.Content className="flex-1 min-h-0 overflow-auto">
        <UserTable
          counts={counts}
          statuses={statuses}
          statusLoading={loading}
        />
      </Page.Content>
    </Page>
  )
}

export default UserPage
